
<script>
  import { Bar} from 'vue-chartjs'

  export default {
    extends: Bar,
    props: [
      'chartData',
      'chartLabels',
      'currentAqiReading'
    ],
    watch: {
    },
    data () {
      return {
        chartDataLocal: [],
        chartLabelsLocal: [],
        chartColors: [],
        options: {
          scales: {
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'AQI class',
                fontSize: 16
              },
              ticks: {
                beginAtZero: true,
                max: 5,
                min: 0,
                stepSize: 1
              },
              gridLines: {
                display: true,
                color: 'rgba(255,255,255,.5)',
                zeroLineColor: 'rgba(255,255,255,.5)'
              }
            }],
            xAxes: [ {
              gridLines: {
                display: true,
                color: 'rgba(255,255,255,.5)',
                zeroLineColor: 'rgba(255,255,255,.5)'
              },
              ticks: {
                display: true
              }
            }]
          },
          legend: {
            display: false
          },
          responsive: true,
          maintainAspectRatio: false,
          title: {
              display: true,
              text: 'Data History',
              fontSize: 16
          },
          animation: {
            duration: 0
          }
        }
      }
    },
    mounted () {
      this.initChart();
    },
    methods: {
      initChart(){
        this.displayChart();
      },
      displayChart() {
        this.chartDataLocal = JSON.parse(JSON.stringify(this.chartData));
        this.chartDataLocal.push(this.currentAqiReading);
        this.chartLabelsLocal = JSON.parse(JSON.stringify(this.chartLabels));
        this.chartLabelsLocal.push('Current');
        //this.chartLabelsLocal = this.chartLabelsLocal.map(() => '');
        this.formatColorValues();
        this.renderChart({
          labels: this.chartLabelsLocal,
          datasets: [
            {
              //label: 'downloads',
              borderColor: 'white',
              //pointBackgroundColor: 'white',
              borderWidth: 0,
              pointBorderColor: '#249EBF',
              backgroundColor: this.chartColors,
              data: this.chartDataLocal
            }
          ]
        }, this.options)
      },
      formatColorValues() {
        let data = this.chartDataLocal.map(value =>{
          let color;
          switch (value) {
            case 1:
              color = '#00AEF4'
              break;
            case 2:
              color = '#FFFE06'
              break;
            case 3:
              color = '#FFC000'
              break;
            case 4:
              color = '#FE0002'
              break;
            case 5:
              color = '#7330A1'
              break;
          }
          return color;
        });
        this.chartColors = data;
      }
    }
  }
</script>

<style lang="scss">
#bar-chart {
  background: #89deff;
}
</style>